import { init, replayIntegration, browserTracingIntegration } from "@sentry/remix";
import { RemixBrowser, useLocation, useMatches } from "@remix-run/react";
import { startTransition, StrictMode, useEffect } from "react";
import { hydrateRoot } from "react-dom/client";

init({
    dsn: "https://63ead288280f4a584dfb294e82c48dcb@o4511296832667648.ingest.de.sentry.io/4511296834306128",
    // 0.2 keeps Sentry quota healthy under real merchant traffic.
    tracesSampleRate: 0.2,
    // Disable console-log forwarding to Sentry. Stick to explicit captureException calls.
    enableLogs: false,

    // Bypass the Sentry safeguard that detects browser-extension context.
    // The Shopify embedded admin frame can have extension content scripts injected,
    // which trips the check and causes init() to bail with no events sent.
    // See: https://docs.sentry.io/platforms/javascript/best-practices/browser-extensions/
    skipBrowserExtensionCheck: true,

    integrations: [browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches
    }), replayIntegration({
        maskAllText: true,
        blockAllMedia: true
    })],

    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1,
    sendDefaultPii: true
})

startTransition(() => {
  hydrateRoot(
    document,
    <StrictMode>
      <RemixBrowser />
    </StrictMode>
  );
});